import { CEMessageBase } from './ce-message-base'


export class CEMessage extends CEMessageBase {

}